import { render } from "./Clip.vue?vue&type=template&id=4e43f16a&scoped=true"
import script from "./Clip.vue?vue&type=script&lang=js"
export * from "./Clip.vue?vue&type=script&lang=js"

import "./Clip.vue?vue&type=style&index=0&id=4e43f16a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e43f16a"]])

export default __exports__